import {
  Galaktika_Alliance_Flight_Engineer,
  Galaktika_Luminayan_Talna,
  Galaktika_Mayan_Quetzhua,
  Galaktika_Purgamen_Flight_Captain,
  Galaktika_Razatech_Chief_Navigator,
} from '../../assets/img'

export const Navigator = ({ civilisation }) => {
  switch (civilisation) {
    case 'Purgamen':
      return (
        <img
          alt={`${civilisation} civilisation logo`}
          src={Galaktika_Purgamen_Flight_Captain}
          loading="lazy"
          className="object-contain max-h-[50-vh]"
        ></img>
      )
    case 'Alliance':
      return (
        <img
          alt={`${civilisation} civilisation logo`}
          src={Galaktika_Alliance_Flight_Engineer}
          loading="lazy"
          className="object-contain max-h-[50-vh]"
        ></img>
      )
    case 'Luminayan':
      return (
        <img
          alt={`${civilisation} civilisation logo`}
          src={Galaktika_Luminayan_Talna}
          loading="lazy"
          className="object-contain max-h-[50-vh]"
        ></img>
      )
    case 'Razatech':
      return (
        <img
          alt={`${civilisation} civilisation logo`}
          src={Galaktika_Razatech_Chief_Navigator}
          loading="lazy"
          className="object-contain max-h-[50-vh]"
        ></img>
      )
    case 'Axolotl':
      return (
        <img
          alt={`${civilisation} civilisation logo`}
          src={Galaktika_Mayan_Quetzhua}
          loading="lazy"
          className="object-contain max-h-[50-vh]"
        ></img>
      )
    default:
      break
  }
}
